import { Component } from '@angular/core';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { FormBuilder, NgControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/shared/validators/custom-validators';
import { PurchaseOrderDetails } from './purchase-order-details.models';
import { MatSelectChange } from '@angular/material/select';
import { takeUntil } from 'rxjs/operators';

const purchaseOrderFormConfig: FormConfig<PurchaseOrderDetails> = {
	poAmount: ['', [CustomValidators.mustBeNumeric, Validators.min(0)]],
	alertAmount: ['', [CustomValidators.mustBeNumeric, Validators.min(0)]],
	estimatedSpend: [''],
	alertEmailAddresses: [''],
	poNumber: [''],
	alertThresholdPercentage: [null, [Validators.required]],
};

@Component({
	selector: 'rpfsa-purchase-order-details',
	templateUrl: './purchase-order-details.component.html',
})
export class PurchaseOrderDetailsComponent extends CustomFormAccessor<PurchaseOrderDetails> {
	readonly alertThresholdPercentages = [5, 10, 15, 20, 25];

	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, purchaseOrderFormConfig);
	}

	ngOnInit(): void {
		this.form
			.get('poAmount')
			.valueChanges.pipe(takeUntil(this.destroyed))
			.subscribe((amount: number | null) => {
				const alertThresholdPercentage = this.form.get(
					'alertThresholdPercentage'
				).value;
				const alertAmount =
					((100 - alertThresholdPercentage) / 100) * (amount ?? 0);
				const roundUpAlertAmount = Math.ceil(alertAmount * 100) / 100;
				this.form.patchValue({
					alertAmount: roundUpAlertAmount,
				});
			});
	}

	writeValue(value: PurchaseOrderDetails): void {
		if (value) {
			if (!value.alertThresholdPercentage && !value.poAmount) {
				value.alertThresholdPercentage = 20;
				value.alertAmount = 0.2 * (value.poAmount ?? 0);
			}
		}
		super.writeValue(value);
	}

	alertThresholdPercentageChange(change: MatSelectChange) {
		const poAmount = this.form.get('poAmount').value;
		const alertAmount = ((100 - change.value) / 100) * (poAmount ?? 0);
		const roundupAlertAmount = Math.ceil(alertAmount * 100) / 100;
		this.form.patchValue({
			alertAmount: roundupAlertAmount,
		});
	}
}
